<template>
  <img
    v-bind="$attrs"
    :src="previewImg"
    class="qn-image"
    alt="图片">
</template>

<script>
import loadingImg from '@/assets/interfaceSetting/pic_loading.png'

export default {
  name: 'QnImage',
  props: {
    realImg: {
      type: String,
      default: ''
    },
    loadingImg: {
      type: String,
      default: loadingImg
    }
  },
  data() {
    return {
      previewImg: ''
    }
  },
  watch: {
    realImg(val) {
      this.proxySetSrc(val)
    }
  },
  created() {
    if (this.realImg) {
      this.proxySetSrc(this.realImg)
    } else {
      this.setSrc(this.loadingImg)
    }
  },
  methods: {
    setSrc(url) {
      this.previewImg = url
    },
    proxySetSrc(url) {
      this.setSrc(this.loadingImg)
      const img = document.createElement('img')
      img.onload = () => {
        this.setSrc(url)
      }
      img.src = url
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QnImage/index.vue?2e6499a0